import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {LocalStorage} from '@ngx-pwa/local-storage';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';
import {catchError} from 'rxjs/internal/operators';
import {throwError as observableThrowError} from 'rxjs';
import {MatSnackBar} from '@angular/material';
import * as moment from 'moment';

export class Atendimento {

  constructor(fields?: {
    empresaId: number;
    usuarioId: number;
    nomeVendedor: string;
    resultado: string;
    data: string;
    dados: {
      loja: number,
      motivo: null,
      submotivo: string,
      descricao: string,
      produtos: any,
      servico: {},
      venda: {},
      perfil: {}
    };
  }) {
    if (fields) {
      Object.assign(this, fields);
    }
  }
}

@Injectable({
  providedIn: 'root'
})

export class AtendimentoService {
  atendimento;
  atendimentosOffline = [];
  atendimentosOnline = [];
  private apiUrl = environment.apiUrl;
  private atendimentosUrl = `${this.apiUrl}public/atendimentos`;

  constructor(private _http: HttpClient, protected _localStorage: LocalStorage,
              private _router: Router, public _snackBar: MatSnackBar) {
    this.getAtendimentosOnline().subscribe(atendimentos => {
      if (atendimentos) {
        this.atendimentosOnline = atendimentos;
      }
    });
  }

  initAtendimento(atendimento) {
    this.atendimento = new Atendimento(atendimento);
    return this._localStorage.setItem('atendimentoAberto', this.atendimento);
  }

  getAtendimento() {
    this._localStorage.getItem('atendimentoAberto').subscribe(atendimento => {
      this.atendimento = atendimento;
    });
    return this._localStorage.getItem('atendimentoAberto');
  }

  clearDados() {
    const loja = this.atendimento.dados.loja;
    const dados = {
      loja: loja,
      motivo: null,
      submotivo: null,
      descricao: null,
      produtos: [],
      servico: {},
      venda: {},
      perfil: {}
    };
    return dados;
  }

  setAtendimento(atendimento) {
    this.atendimento = atendimento;
    return this._localStorage.setItem('atendimentoAberto', atendimento);
  }

  removeAtendimento() {
    return this._localStorage.removeItem('atendimentoAberto');
  }

  saveAtendimento(atendimento, conexao ?) {
    this.atendimento = {};
    this._localStorage.removeItemSubscribe('atendimentoAberto');
    return this._http.post(this.atendimentosUrl, atendimento).pipe(
      map((data) => {
        if (conexao !== 'offline') {
          this.openSnackSuccess();
        }
        this.atendimentosOnline.push(atendimento);
        this._localStorage.setItemSubscribe('atendimentosEnviadosHoje', this.atendimentosOnline);
        return <any>data;
      }),
      catchError(err => this.catchError(err, atendimento, conexao)));
  }

  getUltimaLoja() {
    return this._localStorage.getItem('ultimaLoja');
  }

  setUltimaLoja(loja) {
    return this._localStorage.setItem('ultimaLoja', {data: moment().format('YYYY/MM/DD'), loja: loja});
  }

  removeUltimaLoja() {
    return this._localStorage.removeItemSubscribe('ultimaLoja');
  }

  setAtendimentosOffline(newAtendimentos) {
    this.atendimentosOffline = newAtendimentos;
    return this._localStorage.setItem('atendimentos', newAtendimentos);
  }

  getAtendimentosOnline() {
    return this._localStorage.getItem('atendimentosEnviadosHoje');
  }

  removeAtendimentosOnline() {
    this._localStorage.removeItemSubscribe('atendimentosEnviadosHoje');
  }

  getAtendimentosOffline() {
    return this._localStorage.getItem('atendimentos');
  }

  saveAtendimentoOffline(atendimento) {
    this.atendimentosOffline.push(atendimento);
    return this._localStorage.setItem('atendimentos', this.atendimentosOffline);
  }

  catchError(err, atendimento, conexao) {
    if ((!navigator.onLine || err.status === 0) && conexao !== 'offline') {
      this.saveAtendimentoOffline(atendimento).subscribe(() => {
        this.openSnackSuccess();
        this._router.navigate(['/mobile']);
      });
    }
    return observableThrowError(err || 'Server error');
  }

  openSnackSuccess() {
    this._snackBar.open('Atendimento Salvo com Sucesso!', 'OK',
      {duration: 2000, panelClass: ['success', 'snack-tab-above'], verticalPosition: 'bottom'});
  }
}
